import { render } from "./StepperSummary.vue?vue&type=template&id=72fb76c0"
import script from "./StepperSummary.vue?vue&type=script&lang=js"
export * from "./StepperSummary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
